import { render, staticRenderFns } from "./ClientInfoManage.vue?vue&type=template&id=94ab9814&scoped=true&"
import script from "./ClientInfoManage.vue?vue&type=script&lang=js&"
export * from "./ClientInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoManage.vue?vue&type=style&index=0&id=94ab9814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ab9814",
  null
  
)

export default component.exports